export const relatedCampaigns = () => {
  const relatedCampaignsWrapper = document.querySelector(
    "[data-wm-related-campaigns]"
  );

  if (!relatedCampaignsWrapper) {
    return false;
  }

  const getRelatedCampaignsData = async () => {
    const relatedCampaignsURL = `https://wemove.eu/api/campaigns?locale=${window.wemove.page.language.iso}&current-petition=${window.wemove.page.name}`;

    try {
      const response = await fetch(relatedCampaignsURL);

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(error.message);
    }
  };

  const renderRelatedCampaigns = async () => {
    const relatedCampaigns = await getRelatedCampaignsData();

    const relatedCampaignsCards = [
      ...relatedCampaignsWrapper.querySelectorAll(
        "[data-wm-related-campaign-card]"
      ),
    ];

    relatedCampaignsCards.forEach((card, index) => {
      const cardData = relatedCampaigns[index];

      card.querySelector("[data-wm-related-campaign-card-title]").innerHTML =
        cardData.attributes.title;
      card.querySelectorAll("[data-wm-related-campaign-card-link]")[0].href =
        cardData.attributes.url;
      card.querySelectorAll("[data-wm-related-campaign-card-link]")[1].href =
        cardData.attributes.url;
      card.querySelector(
        "[data-wm-related-campaign-card-signatures]"
      ).innerHTML = cardData.attributes.signatures;
      card.querySelector(
        "[data-wm-related-campaign-card-description]"
      ).innerHTML = cardData.attributes.content;

      card.querySelector(
        "[data-wm-related-campaign-card-image]"
      ).src = `https://wemove.eu/${cardData.attributes.featured_image.data.attributes.url}`;
      card.querySelector("[data-wm-related-campaign-card-image]").alt =
        cardData.attributes.image_alternative_text;
    });

    relatedCampaignsWrapper.classList.remove("loading");
  };

  renderRelatedCampaigns();
};
